"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HtmlButtonType = exports.UtilityButtonType = exports.RoundButtonType = exports.LinkButtonType = exports.ActionButtonType = exports.ButtonType = void 0;
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var Icon_1 = __importDefault(require("../icon/Icon"));
var Badge_1 = __importDefault(require("../badge/Badge"));
var DeprecationUtils_1 = require("../../utils/DeprecationUtils");
var ButtonType;
(function (ButtonType) {
    ButtonType["ACTION"] = "action";
    ButtonType["FEATURED"] = "featured";
    ButtonType["LINK"] = "link";
    ButtonType["PRIMARY"] = "primary";
    ButtonType["ROUND"] = "round";
    ButtonType["UTILITY"] = "utility";
})(ButtonType = exports.ButtonType || (exports.ButtonType = {}));
var ActionButtonType;
(function (ActionButtonType) {
    ActionButtonType["PRIMARY"] = "action-primary";
    ActionButtonType["SECONDARY"] = "action-secondary";
})(ActionButtonType = exports.ActionButtonType || (exports.ActionButtonType = {}));
var LinkButtonType;
(function (LinkButtonType) {
    LinkButtonType["STANDARD"] = "link-standard";
    LinkButtonType["REVERSED"] = "link-reversed";
})(LinkButtonType = exports.LinkButtonType || (exports.LinkButtonType = {}));
var RoundButtonType;
(function (RoundButtonType) {
    RoundButtonType["FLAT"] = "round-flat";
    RoundButtonType["FLAT_PRIMARY"] = "round-flat-primary";
    RoundButtonType["FLAT_SECONDARY"] = "round-flat-secondary";
    RoundButtonType["RAISED"] = "round-raised";
    RoundButtonType["RAISED_PRIMARY"] = "round-raised-primary";
    RoundButtonType["RAISED_SECONDARY"] = "round-raised-secondary";
    RoundButtonType["UTILITY"] = "round-utility";
    RoundButtonType["UTILITY_PRIMARY"] = "round-utility-primary";
    RoundButtonType["UTILITY_SECONDARY"] = "round-utility-secondary";
    RoundButtonType["REVERSED"] = "round-reversed";
})(RoundButtonType = exports.RoundButtonType || (exports.RoundButtonType = {}));
var UtilityButtonType;
(function (UtilityButtonType) {
    UtilityButtonType["STANDARD"] = "utility-standard";
    UtilityButtonType["RAISED"] = "utility-raised";
    UtilityButtonType["REVERSED"] = "utility-reversed";
})(UtilityButtonType = exports.UtilityButtonType || (exports.UtilityButtonType = {}));
var HtmlButtonType;
(function (HtmlButtonType) {
    HtmlButtonType["BUTTON"] = "button";
    HtmlButtonType["RESET"] = "reset";
    HtmlButtonType["SUBMIT"] = "submit";
})(HtmlButtonType = exports.HtmlButtonType || (exports.HtmlButtonType = {}));
var deprecatedButtonTypes = [
    RoundButtonType.FLAT_PRIMARY,
    RoundButtonType.FLAT_SECONDARY,
    RoundButtonType.RAISED_PRIMARY,
    RoundButtonType.RAISED_SECONDARY,
    RoundButtonType.UTILITY_PRIMARY,
    RoundButtonType.UTILITY_SECONDARY
];
var Button = function (props) {
    var children = props.children, classes = props.classes, disabled = props.disabled, htmlButtonType = props.htmlButtonType, onClick = props.onClick, parentRef = props.parentRef, selected = props.selected, small = props.small, title = props.title, type = props.type, variant = props.variant, otherProps = __rest(props, ["children", "classes", "disabled", "htmlButtonType", "onClick", "parentRef", "selected", "small", "title", "type", "variant"]);
    var classNames = getClassNames(classes, disabled, selected, small, type, variant);
    var ariaLabel = title && type === ButtonType.ROUND && title.trim();
    if (deprecatedButtonTypes.indexOf(variant) !== -1) {
        DeprecationUtils_1.logDeprecatedPropValue({
            component: 'Button',
            propName: 'variant',
            versionStart: '1.0.0-beta.176',
            versionEnd: '2.0.0',
            seeMsg: 'The "PRIMARY" and "SECONDARY" round button variants are now obsolete. Please use FLAT, RAISED, UTILITY or REVERSED enum values; e.g. RoundButtonType.UTILITY.'
        });
    }
    return (react_1.default.createElement("button", __assign({ "aria-label": ariaLabel, className: classNames, disabled: disabled, onClick: onClick, ref: parentRef, type: htmlButtonType }, otherProps), react_1.default.Children.map(children, function (child) {
        if (!child) {
            return null;
        }
        if (react_1.default.isValidElement(child) && (child.type === Badge_1.default || child.type === Icon_1.default) && type !== ButtonType.ROUND) {
            return child;
        }
        return react_1.default.createElement("span", { className: "fds-button-label" }, child);
    })));
};
Button.displayName = 'Button';
Button.defaultProps = {
    htmlButtonType: HtmlButtonType.BUTTON,
    type: ButtonType.PRIMARY
};
var getClassNames = function (classes, disabled, selected, small, type, variant) {
    var buttonDetailClasses = [];
    if (type === ButtonType.ROUND) {
        buttonDetailClasses.push('fds-button-round');
        if (variant === RoundButtonType.RAISED || variant === RoundButtonType.RAISED_PRIMARY || variant === RoundButtonType.RAISED_SECONDARY) {
            buttonDetailClasses.push('fds-button-round-raised');
        }
        else if (variant === RoundButtonType.UTILITY || variant === RoundButtonType.UTILITY_PRIMARY || variant === RoundButtonType.UTILITY_SECONDARY) {
            buttonDetailClasses.push('fds-button-utility');
        }
        else if (variant === RoundButtonType.REVERSED) {
            buttonDetailClasses.push('is-reversed');
        }
        if (selected) {
            buttonDetailClasses.push('is-selected');
        }
    }
    else if (type === ButtonType.ACTION) {
        buttonDetailClasses.push('fds-button-action');
        if (variant === ActionButtonType.SECONDARY) {
            buttonDetailClasses.push('fds-button-action-secondary');
        }
    }
    else if (type === ButtonType.LINK) {
        buttonDetailClasses.push('fds-button-link');
        if (variant === LinkButtonType.REVERSED) {
            buttonDetailClasses.push('is-reversed');
        }
    }
    else {
        buttonDetailClasses.push("fds-button-" + type.trim().toLowerCase());
        if (small) {
            buttonDetailClasses.push('fds-button-small');
        }
        if (type === ButtonType.UTILITY) {
            if (variant === UtilityButtonType.RAISED) {
                buttonDetailClasses.push('utility-raised');
            }
            else if (variant === UtilityButtonType.REVERSED) {
                buttonDetailClasses.push('is-reversed');
            }
            if (selected) {
                buttonDetailClasses.push('is-selected');
            }
        }
    }
    return classnames_1.default('fds-button', buttonDetailClasses, {
        'is-disabled': disabled
    }, classes);
};
exports.default = Button;
